import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Language, LanguageService} from '@core/services/language.service';
import {Store} from '@ngxs/store';
import {CurrentClientState} from '@store/current-client/current-client.state';
import {tuiPure} from '@taiga-ui/cdk';
import {
  getCountryForLanguage,
  getLocaleCountryNameForLanguage,
} from '@tisa-group/core/utils/language-helpers';

import {filter, map} from 'rxjs';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguagePickerComponent {
  language$ = this.languageService?.currentLanguage$;

  languages$ = this.store.select(CurrentClientState.getData).pipe(
    map(data => data?.config?.language.available_languages),
    filter(Boolean),
  );

  @Output()
  readonly languageChanged = new EventEmitter<Language>();

  readonly languageControl = new FormControl(
    this.languageService?.currentLanguage$.getValue(),
  );

  constructor(readonly languageService: LanguageService, readonly store: Store) {
    this.languageService.currentLanguage$.subscribe(language =>
      this.languageControl.patchValue(language, {emitEvent: false}),
    );

    this.languageControl.valueChanges.subscribe(language => {
      if (language) {
        this.languageChanged.emit(language);
      }
    });
  }

  selectionChange(event: any) {
    this.languageChanged.emit(event.value);
  }

  @tuiPure
  getCountryForLanguage(languageCode: string) {
    return getCountryForLanguage(languageCode);
  }

  @tuiPure
  getLocaleCountryNameForLanguage(languageCode: string) {
    return getLocaleCountryNameForLanguage(languageCode);
  }
}
